/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation LBRRouteDelete($routeId: ID!) {
    LBRRouteDelete(routeId: $routeId) {
        message
        status
    }
} 
`

